import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import useHttp from "../../../../hooks/use-http";

const QrCodeView = () => {
  const { orgId, plmId } = useParams();
  const [packingdata, setPackingData] = useState();
  const [harvestingdata, setHarvestingData] = useState();
  //console.log(orgId, plmId);

  const { sendRequest: getPackDetail } = useHttp();

  useEffect(() => {
    getPackDetail(
      {
        url: `/api/tracebilityByPkgNo/?orgId=${orgId}&plmId=${plmId}`,
      },
      (res) => {
        //console.log(res);
        setPackingData(res.packaginDetail);
        setHarvestingData(res.harvestingDetail);
      }
    );
  }, [getPackDetail]);

  return (
    <>
      <div className="qr-view-container">
        <div className="qr-box">
          <h2>Packed On</h2>
          <p>Address: 123 Main St</p>
          <p>Date : {packingdata && packingdata.plmDate}</p>
          <p>Product Name: {packingdata && packingdata.packagingProductName}</p>
          <p>Employee Name: {packingdata && packingdata.employeeName}</p>
        </div>
        <div className="qr-box">
          <h2>Harvest</h2>
          <p>Address: {harvestingdata && harvestingdata.address+" "+harvestingdata.city+" "+harvestingdata.state+" "+harvestingdata.country}</p>
          <p>Harvest Date: {harvestingdata && harvestingdata.harvestDate}</p>
          <p>Crop Name: {harvestingdata && harvestingdata.cropName}</p>
          <p>Farmer Name: {harvestingdata && harvestingdata.farmerName}</p>
        </div>
      </div>
    </>
  );
};

export default QrCodeView;
